// src/components/VisitorContactWidget/components/ContactSuccessPanel.jsx

import React from "react";

import {
  FiCheck,
  FiHome,
  FiMessageCircle,
} from "react-icons/fi";

export default function ContactSuccessPanel({
  title,
  message,
  hasConversation,
  onHome,
  onOpenConversation,
}) {
  return (
    <div className="flex min-h-[420px] flex-col items-center justify-center p-6 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 text-3xl text-emerald-600">
        <FiCheck />
      </div>

      <h3 className="mt-5 text-xl font-semibold text-[#123B57]">
        {title}
      </h3>

      <p className="mt-3 max-w-sm text-sm leading-6 text-slate-500">
        {message}
      </p>

      <div className="mt-7 grid w-full gap-2">
        {hasConversation && (
          <button
            type="button"
            onClick={onOpenConversation}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#123B57] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#1C567F]"
          >
            <FiMessageCircle />
            Voir la conversation
          </button>
        )}

        <button
          type="button"
          onClick={onHome}
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 py-3 text-sm font-bold text-slate-600 transition hover:bg-slate-50"
        >
          <FiHome />
          Retour à l’accueil
        </button>
      </div>
    </div>
  );
}